import React from "react";

const featuresContent = [
  {
    icon: "149",
    title: "CCCD mới",
    desc: `Định danh điện tử với độ chính xác 100% nhờ công nghệ NFC `,
    delayAnimation: "",
  },
  {
    icon: "150",
    title: "Chống giả mạo",
    desc: `Chống giả mạo giấy tờ qua việc định danh công dân với CSDLQG về dân cư`,
    delayAnimation: "100",
  },
  {
    icon: "151",
    title: "Xác minh danh tính",
    desc: `Phát hiện các khuôn mặt không đáp ứng các yêu cầu tối thiểu,
    khuôn mặt bị che khuất hoặc nhắm mắt`,
    delayAnimation: "200",
  },
];

const FancyFeatureTewentyEight = () => {
  return (
    <div className="row justify-content-between">
      {featuresContent.map((val, i) => (
        <div
          className="col-xl-3 col-md-4"
          data-aos="fade-up"
          data-aos-delay={val.delayAnimation}
          key={i}
        >
          <div className="block-style-twentyEight text-center mt-40">
            <div className="icon d-flex justify-content-center align-items-end">
              <img src={`images/icon/${val.icon}.svg`} alt="icon" />
            </div>
            <h4>{val.title}</h4>
            <p>{val.desc}</p>
          </div>
          {/* /.block-style-twentyEight */}
        </div>
      ))}
    </div>
  );
};

export default FancyFeatureTewentyEight;
